import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { ProblemModel } from './model';
import { problemAdapter, ProblemState } from './state';

export const stateName: string = 'problem';

export const getError = (state: ProblemState): any => state.error;

export const getIsLoading = (state: ProblemState): boolean => state.isLoading;

export const getSelected = (state: ProblemState): ProblemModel => state.selected;

export const selectProblemState: MemoizedSelector<object, ProblemState> = createFeatureSelector<ProblemState>(stateName);

export const selectAll: (state: object) => ProblemModel[] = problemAdapter.getSelectors(selectProblemState).selectAll;

export const selectById = (id: number) =>
  createSelector(selectAll, (problems: ProblemModel[]) => {
    return problems ? problems.find(p => p.id === id) : null;
  });

export const selectSelected: MemoizedSelector<object, ProblemModel> = createSelector(selectProblemState, getSelected);

export const selectError: MemoizedSelector<object, any> = createSelector(selectProblemState, getError);

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectProblemState, getIsLoading);
